import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector5KBlue5CRed = ({ state, workState }) => (
   <g id="Track-5K-blue-connector" transform="translate(1455.000000, 383.000000)">
      {/*<g strokeLinecap="round"*/}
      {/*   stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}*/}
      {/*>*/}
      {/*   <g transform="translate(356.646930, 0.000000)">*/}
      {/*      <polyline*/}
      {/*         id="arrow" strokeWidth={arrowWidth} strokeLinejoin="round"*/}
      {/*         transform="translate(56.729887, 46.696942) rotate(-64.000000) translate(-56.729887, -46.696942) "*/}
      {/*         points="60.7298867 54.6969422 52.7298867 46.6969422 60.7298867 38.6969422"*/}
      {/*      />*/}

      {/*      <path*/}
      {/*         d="M40,0 L50.0152384,7.91899207 C61.6950374,17.1541427 64.8337541,33.5584751 57.3881249,46.4529822 L56.0693665,48.7368374 L56.0693665,48.7368374"*/}
      {/*         strokeWidth={tracksWidth}*/}
      {/*      />*/}
      {/*      <line x1="0.353070205" y1="122" x2="49.3530702" y2="62" id="Path" strokeWidth={tracksWidth}/>*/}
      {/*   </g>*/}
      {/*</g>*/}
   </g>
);

export default Connector5KBlue5CRed;
